import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsOpen, selectIsMobile, toggleSidebar } from '../store/slices/sidebarSlice';
import { selectIsAuthenticated } from '../store/slices/authSlice';

const MobileMenuButton = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsOpen);
  const isMobile = useSelector(selectIsMobile);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  // Only show on mobile when sidebar is closed and user is authenticated
  if (!isMobile || isOpen || !isAuthenticated) {
    return null;
  }

  return (
    <button
      onClick={() => dispatch(toggleSidebar())}
      className="fixed top-4 left-4 z-50 bg-gray-800 text-white p-3 rounded-lg shadow-lg hover:bg-gray-700 transition-colors duration-200"
      aria-label="Open menu"
    >
      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
  );
};

export default MobileMenuButton;
